(() => {
  const normalizeEmailLinks = () => {
    document.querySelectorAll('a[href*="@"]:not([href^="mailto:"])').forEach((link) => {
      const href = link.getAttribute('href')?.trim();
      if (!href || href.includes('://') || href.startsWith('/') || href.startsWith('#')) return;

      const email = href.replace(/^email:/i, '').split('?')[0];
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        link.href = `mailto:${href.replace(/^email:/i, '')}`;
      }
    });
  };

  const activateVideo = (root) => {
    const sourceUrl = root?.dataset.videoSrc;
    const button = root?.querySelector('.nh-deferred-product-video__button');
    const video = root?.querySelector('.nh-deferred-product-video__player');
    if (!root || !button || !video || !sourceUrl || root.dataset.videoLoaded === 'true') return;

    root.dataset.videoLoaded = 'true';
    video.controls = true;
    video.autoplay = true;
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'auto';

    const source = document.createElement('source');
    source.src = sourceUrl;
    source.type = root.dataset.videoType || 'video/mp4';
    video.appendChild(source);

    video.load();
    video.play().catch(() => {});
  };

  const isActive = (root) =>
    root.closest('.product-media--root')?.dataset.active === 'true';

  const queueAutoplay = (root, delay = 2500) => {
    if (!root || root.dataset.videoQueued === 'true') return;
    root.dataset.videoQueued = 'true';
    window.setTimeout(() => {
      root.dataset.videoQueued = 'false';
      if (isActive(root)) activateVideo(root);
    }, delay);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.nh-deferred-product-video__button');
    if (button) activateVideo(button.closest('.nh-deferred-product-video'));
  });

  const videoRoots = [...document.querySelectorAll('.nh-deferred-product-video')];
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && isActive(entry.target)) {
        queueAutoplay(entry.target);
      }
    });
  }, { threshold: 0.35 });

  videoRoots.forEach((root) => {
    observer.observe(root);
    const mediaRoot = root.closest('.product-media--root');
    if (!mediaRoot) return;

    new MutationObserver(() => {
      if (isActive(root)) queueAutoplay(root, 350);
    }).observe(mediaRoot, { attributes: true, attributeFilter: ['data-active'] });
  });

  normalizeEmailLinks();
})();
